import DOMPurify from "dompurify";
import { useMemo } from "react";

const decodeHTML = (encodedHTML) => {
  if (!encodedHTML) return "";
  const textarea = document.createElement("textarea");
  textarea.innerHTML = encodedHTML;
  return textarea.value;
};

const CaseStudy = ({ html }) => {
  const sanitizedHTML = useMemo(() => {
    const decoded = decodeHTML(html);
    return DOMPurify.sanitize(decoded, {
      USE_PROFILES: { html: true },
    });
  }, [html]);
  return (
    <div
      className="case-study-wrapper"
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};

export default CaseStudy;
